import {
  TabGroup as HeadlessTabGroup,
  type TabGroupProps as HeadlessTabGroupProps,
} from "@headlessui/react";
import classNames from "classnames";
import { type ElementType, type ReactNode } from "react";

import TabContext from "./TabContext";

type TabGroupProps<TTag extends ElementType = "div"> = {
  size?: keyof typeof sizes;
  variant?: "primary" | "secondary";
  vertical?: boolean;
  children: ReactNode;
} & HeadlessTabGroupProps<TTag>;

const sizes = {
  sm: "h-11",
  md: "h-12",
};

export default function TabGroup({
  size = "md",
  variant = "primary",
  vertical = false,
  children,
  className,
  ...props
}: TabGroupProps<"div">) {
  return (
    <TabContext.Provider value={{ size, variant, vertical }}>
      <HeadlessTabGroup
        {...(props as any)}
        className={classNames(vertical ? "flex gap-6" : "", className)}
      >
        {children}
      </HeadlessTabGroup>
    </TabContext.Provider>
  );
}
